/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'skype': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#15ace5" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M26.664 18.063c.124-.639.19-1.298.19-1.974 0-5.675-4.6-10.275-10.275-10.275-.675 0-1.335.066-1.974.19a5.93 5.93 0 00-8.111 8.111c-.124.639-.19 1.298-.19 1.974 0 5.675 4.6 10.275 10.275 10.275.675 0 1.335-.066 1.974-.19a5.93 5.93 0 008.111-8.111zm-9.89 5.083c-3.651 0-5.477-1.369-6.039-3.09s.667-2.212 1.053-2.247 1.205.058 1.439.772c.243.742 1.053 2.212 2.809 2.387s2.914-.632 3.265-1.475-.281-2.001-2.984-2.387-5.512-1.58-5.512-4.283 3.09-3.792 6.039-3.792 4.444 1.666 4.775 2.317c.41.807.269 2.153-.702 2.387-1.018.246-1.545-.316-2.282-1.685-.762-1.416-3.476-1.053-4.389-.246s-.667 1.966 3.125 2.703 5.196 2.107 5.196 4.248-2.142 4.389-5.793 4.389z"/>'
  }
})
